module.exports = __webpack_public_path__ + "img/application-dark.d55f46fc.svg";